﻿import { ValidationSummary } from "shared/data/validation";

export class ProcessingResult {
    static AccessDenied = 'accessDenied';
    static AddressMismatch = 'addressMismatch';
    static AlreadyProcessed = 'alreadyProcessed';
    static ConfigurationError = 'configurationError';
    static FailedValidationCheck = 'failedValidationCheck';
    static MissingOrAmbiguousMessageType = 'missingOrAmbiguousMessageType';
    static MissingOrAmbiguousResponseField = 'missingOrAmbiguousResponseField';
    static MissingTrackingId = 'missingTrackingId';
    static NoActions = 'noActions';
    static OtherBatchItemsFailed = 'otherBatchItemsFailed';
    static ProcessingSuccessful = 'processingSuccessful';
    static ResponseDoesNotSupportNewItems = 'responseDoesNotSupportNewItems';
    static UnknownMessageType = 'unknownMessageType';
    static UnknownTrackingId = 'unknownTrackingId';
    static UnknownUser = 'unknownUser';
    static UnknownWorkItemError = 'unknownWorkItemError';
    static UnrecognizedResponse = 'unrecognizedResponse';
    static UnsupportedBatchOperation = 'unsupportedBatchOperation';
    static ValidationFailed = 'validationFailed';
    static WorkItemNotAvailableForClaim = 'workItemNotAvailableForClaim';
    static WorkItemClaimedByAnotherUser = 'workItemClaimedByAnotherUser';
    static WorkItemProgressedToNextStep = 'workItemProgressedToNextStep';
} 

export class NotificationProcessingResult {
    result: string; // ProcessingResult
    validationSummary?: ValidationSummary;
    validResponses?: string[];

    public IsSuccessful(): boolean {
        return this.result === ProcessingResult.ProcessingSuccessful;
    }
}



